import React from 'react';

const BubbleView = ({ count, where }) => {
  return (
    <div className={`notfication-bubble ${where}`}>
      <span>{count}</span>
    </div>
  );
}

export default BubbleView;
